export function downloadFile(file: Blob, filename: string) {
  const url = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function downloadCsv(csv: string, filename: string) {
  downloadFile(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), filename);
}
